import { checkLanguage } from "../../utils/setLanguage";
import { cache } from "../persistence/cache";

let allProfiles = null;

const update = function(profilesList) {
  for (const profile of profilesList) {
    profile.language = checkLanguage(profile.language);
  }
  if (this.localCache && this.localCache.auth) {
    cache.set("allProfiles", profilesList, {
      database: "auth",
      expiresIn: this.currentProfileExpirationTime
    });
  }
};

const get = async function() {
  if (this.localCache && this.localCache.auth) {
    allProfiles = await cache.get("allProfiles", { database: "auth" });
    for (const profile of allProfiles) {
      profile.language = checkLanguage(profile.language);
    }
  }

  return allProfiles;
};

const deleteAllProfile = async function() {
  await cache.remove("allProfiles", { database: "auth" });
};

export default { update, get, deleteAllProfile };
